import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import MakeUser from "../manage/users/MakeUser";
import MakePassword from "../manage/users/MakePassword";
import Title from "../../components/elements/Title";
import {isAdmin, isSupplier} from "../../../config/Permissions";
import {MenuItem, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import LogoutDialog from "../../components/layout/components/LogoutDialog";



function OrganizationsPage({edit}){
    const { t } = useTranslation();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    },[]);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('accountDetails')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <Title align="left" color="text" className="panel-title">{t('accountDetails')}</Title>
                </Grid>
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <MakeUser details/>
                </Grid>
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <Title align="left" color="text" className="panel-title">{t('passwordSettings')}</Title>
                </Grid>
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <MakePassword/>
                </Grid>
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <Title align="left" color="text" className="panel-title">{t('logout')}</Title>
                </Grid>
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <div style={{display:"flex",gap:10,alignItems:"center",justifyContent:"space-between",padding:20,backgroundColor:"#fdf4f5",borderRadius:12,}}>
                        <Typography>
                            {t('doYouWantToLogout')}
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={() => setDialogOpen(true)}
                            size="small"
                            style={{width:150}}

                        >
                            {t('logout')}
                        </Button>
                        <LogoutDialog logoutOpen={dialogOpen} closeDialog={() => setDialogOpen(false)}/>

                    </div>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(OrganizationsPage);
